import { render, staticRenderFns } from "./zbBuy.vue?vue&type=template&id=2e9aa1de&scoped=true&"
import script from "./zbBuy.vue?vue&type=script&lang=js&"
export * from "./zbBuy.vue?vue&type=script&lang=js&"
import style0 from "./zbBuy.vue?vue&type=style&index=0&id=2e9aa1de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9aa1de",
  null
  
)

export default component.exports